import React, { useContext, useEffect, useRef } from "react";
import { connect, useSelector } from "react-redux";
import flv from "flv.js";
import Hls from "hls.js";
// import { fetchStream } from "../../actions";
import { fetchStream } from ".././../action";
import { getUserDetail } from "../../constants/function";
import { SocketContext } from "../../context/socket";
import { OBS_CHANNEL_URL } from "../../constants/api";

const userData = getUserDetail();

export default function StreamShow({ obsUrl: propObsUrl, fromObs, channelName }) {
  const videoRef = useRef(null);
  let player = useRef(null);
  const { count } = useSelector((state) => state.adv);

  // If obsUrl is passed as prop, use it; otherwise construct from channelName
  // Use HTTPS to avoid mixed content issues
  const obsUrl = propObsUrl || `https://staging-media.siki.io/hls/${channelName}.m3u8`;

  console.log("fromObs=", fromObs, "obsUrl=", obsUrl);
  const socket = useContext(SocketContext).Socket;
  const [flip, setFlip] = React.useState(false);

  useEffect(() => {
    if (socket) {
      socket.on("video-flip-true", function (data) {
        if (data.channelName === channelName && data.isflip) {
          setFlip(true);
        } else {
          setFlip(false);
        }
      });
    }
  }, [socket, channelName]);

  useEffect(() => {
    fetchStream(channelName);

    // Cleanup old player if it exists
    if (player.current) {
      console.log('[StreamShow] Cleaning up old player');
      if (player.current.destroy) {
        player.current.destroy();
      } else if (player.current.detachMedia) {
        player.current.detachMedia();
      }
      player.current = null;
    }

    buildPlayer();

    return () => {
      if (player.current) {
        if (player.current.destroy) {
          player.current.destroy();
        } else if (player.current.detachMedia) {
          player.current.detachMedia();
        }
        player.current = null;
      }
    };
  }, [channelName, fromObs, obsUrl]);

  const buildPlayer = () => {
    console.log('[StreamShow] buildPlayer called - channelName:', channelName, 'fromObs:', fromObs, 'obsUrl:', obsUrl, 'player.current:', !!player.current);
    if (!channelName && !fromObs) {
      console.log('[StreamShow] No channelName or fromObs, skipping');
      return;
    }
    if (player.current) {
      console.log('[StreamShow] Player already exists, skipping');
      return;
    }

    // All streams use HLS playback (both OBS and camera streams via Media Push)
    console.log("** HLS URL: " + obsUrl);

    // Check if browser supports HLS natively (Safari)
    if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
      console.log('[StreamShow] Using native HLS support');
      videoRef.current.src = obsUrl;
      videoRef.current.addEventListener('error', (e) => {
        console.error('[StreamShow] Native HLS error:', e, videoRef.current.error);
      });
    } else if (Hls.isSupported()) {
      console.log('[StreamShow] Using hls.js with low-latency config');
      player.current = new Hls({
        enableWorker: true,
        lowLatencyMode: true,
        backBufferLength: 10,
        maxBufferLength: 3,
        maxMaxBufferLength: 6,
        maxBufferSize: 10 * 1000 * 1000,
        maxBufferHole: 0.5,
        highBufferWatchdogPeriod: 1,
        nudgeOffset: 0.1,
        nudgeMaxRetry: 3,
        maxFragLookUpTolerance: 0.1,
        liveSyncDurationCount: 1,
        liveMaxLatencyDurationCount: 3,
        liveDurationInfinity: true,
        debug: false,
      });
      player.current.loadSource(obsUrl);
      player.current.attachMedia(videoRef.current);

      player.current.on(Hls.Events.MANIFEST_PARSED, () => {
        console.log('[StreamShow] HLS manifest parsed, attempting to play');
        const duration = videoRef.current.duration;
        if (duration && isFinite(duration)) {
          videoRef.current.currentTime = duration - 1;
          console.log('[StreamShow] Jumped to live edge:', duration - 1);
        }
        videoRef.current.play().catch(err => {
          console.error('[StreamShow] Play error:', err);
        });
      });

      let liveEdgeInterval = null;
      player.current.on(Hls.Events.FRAG_LOADED, () => {
        if (!liveEdgeInterval) {
          liveEdgeInterval = setInterval(() => {
            const duration = videoRef.current.duration;
            const currentTime = videoRef.current.currentTime;
            const latency = duration - currentTime;

            if (latency > 3 && isFinite(duration)) {
              console.log('[StreamShow] Latency too high:', latency, 'jumping to:', duration - 1);
              videoRef.current.currentTime = duration - 1;
            }
          }, 2000);
        }
      });

      player.current.on(Hls.Events.ERROR, (event, data) => {
        console.error('[StreamShow] HLS error:', data);
        if (data.fatal) {
          console.error('[StreamShow] Fatal HLS error, type:', data.type);
          if (data.type === Hls.ErrorTypes.NETWORK_ERROR) {
            console.log('[StreamShow] Network error, attempting recovery');
            player.current.startLoad();
          } else if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {
            console.log('[StreamShow] Media error, attempting recovery');
            player.current.recoverMediaError();
          }
        }
      });
    } else {
      console.error('HLS is not supported in this browser');
    }
  };

  useEffect(() => {
    if (count) {
      videoRef.current.muted = true;
    } else {
      videoRef.current.muted = false;
    }
  }, [count]);
  // console.log("channelName", channelName);
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        backgroundColor: "black",
      }}
    >
      <video
        ref={videoRef}
        style={{
          width: "100%",
          height: "100%",
          // objectFit: "cover",
          // backgroundColor: "black",
          position: "absolute",
          left: "0px",
          top: "0px",
          transform: !flip ? "rotateY(180deg)" : "",
          objectFit: "contain",
        }}
        // controls
        autoPlay
      />
    </div>
  );
}
